import React, { useMemo } from 'react';
import classNames from 'classnames';
import { type StatisticPlaygroundDataResContent as PlayGroundResDataType } from '../../api/playgroundApi';
import { Marker, type MarkerProps } from './MtvMap';
import { Image } from '../../components/Image';
import styles from './PGMap.module.scss';

interface MarkerItemNewProps {
  data: PlayGroundResDataType;
  showCount: boolean;
  highlightSerialNo?: string;
  onClick?: (item: PlayGroundResDataType, options: MarkerProps) => void;
}

export const PGMarkerItemNew = (props: MarkerItemNewProps) => {
  const { data, showCount, highlightSerialNo, onClick } = props;
  const { imgSrc, count, latitude, longitude, name } = data;
  const lnglat = useMemo(() => ({ lng: Number(longitude), lat: Number(latitude) }), [longitude, latitude]);
  const offsets = useMemo(() => [0, 20] as [number, number], []);

  const isHighlighted = !!(highlightSerialNo && data.serialNo === highlightSerialNo);

  const onClickMarker = () => {
    if (latitude && longitude) {
      if (typeof onClick === 'function') onClick(data, { lnglat });
    }
  };

  return (
    <Marker lnglat={lnglat} offsets={offsets}>
      <div
        className={classNames(styles['marker-container'], 'l7-marker', isHighlighted && styles.highlighted)}
        onClick={onClickMarker}
        data-no={data.serialNo}
      >
        <div className={styles['marker-container-box']}>
          <div className={styles['img-container']}>
            <Image src={imgSrc} layout="responsive" width={120} height={120} />
          </div>
          {showCount && <div className={styles['count-container']}>{count}</div>}
          <div className={styles['popover-arrow']} />
        </div>
        {name && <div className={styles['name-label']}>{name}</div>}
      </div>
    </Marker>
  );
};
